<script>
  import { onMount, onDestroy } from 'svelte';
  import Chart from 'chart.js/auto';

  export let title = '';
  export let datasets = [];
  export let labels = [];
  export let height = 300;

  let chartCanvas;
  let chart;

  onMount(() => {
    if (!chartCanvas) return;

    const ctx = chartCanvas.getContext('2d');

    chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: datasets.map((dataset, idx) => ({
          label: dataset.label,
          data: dataset.data,
          backgroundColor: dataset.color || `rgba(59, 130, 246, ${1 - idx * 0.3})`,
          borderRadius: 4,
        }))
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'top',
            align: 'start',
            labels: {
              usePointStyle: true,
              boxWidth: 8,
            }
          }
        },
        scales: {
          x: {
            stacked: true,
            grid: {
              display: false
            }
          },
          y: {
            stacked: true,
            beginAtZero: true,
            grid: {
              display: true,
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }
        }
      }
    });
  });

  onDestroy(() => {
    if (chart) {
      chart.destroy();
    }
  });

  $: if (chart && datasets && labels) {
    chart.data.labels = labels;
    chart.data.datasets = datasets.map((dataset, idx) => ({
      label: dataset.label,
      data: dataset.data,
      backgroundColor: dataset.color || `rgba(59, 130, 246, ${1 - idx * 0.3})`,
      borderRadius: 4,
    }));
    chart.update();
  }
</script>

<div class="bg-white rounded-lg border border-gray-200 p-6">
  <h3 class="text-lg font-semibold text-gray-900 mb-4">{title}</h3>

  <div style="height: {height}px;">
    <canvas bind:this={chartCanvas}></canvas>
  </div>
</div>
